<template>
  <div class="offlineMessage" :style="{display: showMessage ? 'block' : 'none'}">
    <span>{{message}}</span>
  </div>
</template>

<script>
  export default {
    name: 'OfflineMessageView',
    data () {
      return {
        message: 'Работа офлайн',
        showMessage: false
      }
    },
    created() {

    },
    mounted() {
      const self = this;
      if (!navigator.onLine) {
        this.showMessage = true;
      }

      window.ononline = function() {
        self.showMessage = false;
      };
      window.onoffline = function() {
        self.showMessage = true;
      };
    }
  }
</script>

<style lang="scss">
  @import "OfflineMessage.scss";
</style>
